<template>
  <el-dialog :visible="visible" title="撰寫通知" width="800px" top="5vh" :append-to-body="true" @close="$emit('update:visible', false)">
    <div class="main-layout-wrapper">
      <div class="notification-editor">
        <div class="info-card">
          <div v-for="(item, index) in displayInfo" :key="index" class="info-row">
            <div v-if="item.divider" :key="'div-' + index" class="info-divider"></div>
            <div v-else :key="index" class="info-row">
              <span class="label">{{ item.label }}：</span>
              <span class="value">{{ item.value || '無' }}</span>
            </div>
          </div>
        </div>

        <div class="setting-section">
          <p class="section-title">發送方式（複選）</p>
          <el-checkbox-group v-model="form.router" class="full-width-grid">
            <el-checkbox label="email" border>電子郵件</el-checkbox>
            <el-checkbox label="sms" border>簡訊</el-checkbox>
          </el-checkbox-group>

          <template v-if="mode !== 'hotel'">
            <p class="section-title" style="margin-top: 20px;">發送給...（複選）</p>
            <el-checkbox-group v-model="form.sendWhoType" class="full-width-grid">
              <el-checkbox label="onlyUser" border>使用人</el-checkbox>
              <el-checkbox label="onlyBuyer" border>客戶</el-checkbox>
            </el-checkbox-group>
          </template>
        </div>

        <div class="edit-section">
          <div v-if="form.router.includes('email')" class="form-item">
            <p class="section-title">Email 主旨</p>
            <el-input v-model="form.subject" placeholder="請輸入主旨" />
          </div>

          <div class="section-header">
            <p class="section-title">訊息內容</p>
            <div v-if="form.router.includes('sms')" class="sms-counter">
              <span :class="{ 'text-danger': form.templateContent.length > 70 }">
                {{ form.templateContent.length }}
              </span>
              / 70 字
              <el-tag size="mini" type="info" effect="plain" style="margin-left: 8px;"> {{ Math.ceil(form.templateContent.length / 70) || 1 }} 封簡訊 </el-tag>
            </div>
          </div>

          <div class="tag-container">
            <el-button v-for="tag in variableOptions" :key="tag.key" size="mini" round class="variable-btn" @click="insertVariable(tag.key)"> + {{ tag.label }} </el-button>
          </div>

          <el-input ref="contentInput" type="textarea" :rows="5" v-model="form.templateContent" placeholder="請輸入訊息內容..." />

          <div class="preview-container">
            <p class="section-title">預覽：</p>
            <div class="preview-content" v-html="renderedPreview"></div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="footer-center">
      <el-button round @click="$emit('update:visible', false)" class="footer-btn">取消</el-button>
      <el-button round type="primary" :loading="loading" @click="handleConfirm" class="footer-btn">確認發送</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'NotificationEditor',
  props: {
    visible: {
      type: Boolean,
      default: false,
    }, // 由父層控制開關
    displayInfo: {
      type: Array,
      default: () => [],
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    previewMapping: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        router: ['sms'],
        sendWhoType: ['onlyUser'],
        subject: '',
        templateContent: '',
      },
    }
  },
  computed: {
    renderedPreview() {
      if (!this.form.templateContent) return '（暫無預覽內容）'
      let content = this.form.templateContent
      Object.keys(this.previewMapping).forEach((key) => {
        const regex = new RegExp(`{${key}}`, 'g')
        const val = this.previewMapping[key] || `{${key}}`
        content = content.replace(regex, `<span class="preview-tag">${val}</span>`)
      })
      return content.replace(/\n/g, '<br>')
    },
  },
  methods: {
    insertVariable(key) {
      const tagText = `{${key}}`
      const inputEl = this.$refs.contentInput.$refs.textarea
      const start = inputEl.selectionStart
      const end = inputEl.selectionEnd

      this.form.templateContent = this.form.templateContent.substring(0, start) + tagText + this.form.templateContent.substring(end)

      this.$nextTick(() => {
        inputEl.focus()
        inputEl.setSelectionRange(start + tagText.length, start + tagText.length)
      })
    },
    handleConfirm() {
      if (this.form.router.length === 0) {
        this.$message.warning('請至少選擇一種發送方式')
        return
      }

      if (this.form.router.includes('email') && !this.form.subject.trim()) {
        this.$message.warning('請輸入 Email 主旨')
        return
      }

      if (!this.form.templateContent.trim()) {
        this.$message.warning('請輸入訊息內容')
        return
      }
      this.$emit('confirm', { ...this.form })
    },
    resetForm() {
      this.form = {
        router: ['sms'],
        sendWhoType: ['onlyUser'],
        subject: '',
        templateContent: '',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-layout-wrapper {
  padding: 0 10%;
}
.notification-editor {
  max-height: 65vh;
  overflow-y: auto;
}

.full-width-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  width: 100%;
  ::v-deep .el-checkbox {
    margin-right: 0;
    height: 45px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    &.is-bordered.is-checked {
      border-color: #e67e22;
    }
    .el-checkbox__label {
      flex: 1;
    }
    &.is-checked .el-checkbox__label {
      color: #e67e22;
    }
    &.is-checked .el-checkbox__inner {
      background-color: #e67e22;
      border-color: #e67e22;
    }
  }
}

.variable-btn {
  background: #fff5ee;
  border: 1px solid #ffccaa;
  color: #e67e22;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 20px;
}

.info-card {
  background-color: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 25px;
  border: 1px solid #ebeef5;
  .info-row {
    font-size: 14px;
    line-height: 1.8;
    color: #606266;
  }
  .info-divider {
    grid-column: 1 / -1;
    height: 12px;
  }
}

.preview-container {
  margin-top: 20px;
  padding: 15px;
  background: #fffdfb;
  border: 1px dashed #ffdcc3;
  border-radius: 8px;
  ::v-deep .preview-tag {
    color: #e67e22;
    font-weight: bold;
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.sms-counter {
  font-size: 12px;
  color: #909399;

  .text-danger {
    color: #e67e22; // 超過 70 字變色提醒，使用你原本的主題橘色
    font-weight: bold;
  }
}
.footer-center {
  display: flex;
  justify-content: space-around;
  gap: 30px;
  margin: 0px 60px;
  padding-bottom: 20px;
  .footer-btn {
    flex: 1;
  }
}
</style>
